import { Routes, Route } from 'react-router-dom'
import { Box } from '@mui/material'
import Header from '@components/layout/Header'
import Footer from '@components/layout/Footer'
import ScrollToTop from '@components/ScrollToTop'
import HomePage from '@pages/HomePage'
import AboutPage from '@pages/AboutPage'
import ProjectsPage from '@pages/ProjectsPage'
import ContactPage from '@pages/ContactPage'
import NotFoundPage from '@pages/NotFoundPage'
import Founder from "@pages/Founder.jsx";
import ServicesOverviewPage from "@pages/ServicesOverviewPage";
import ServicesPage from "@pages/ServicesPage.jsx";

function App() {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: 'background.default'
    }}>
      <ScrollToTop />
      <Header />
        <Box component="main" sx={{flexGrow: 1}}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/about/founder" element={<Founder />} />
          <Route path="/portfolio" element={<ProjectsPage />} />
          <Route path="/services" element={<ServicesOverviewPage />} />
          <Route path="/services/:serviceId" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  )
}

export default App